export default "__VITE_ASSET__DVJY3$fr__"